/* Translate only exact, known app presentation strings, never control values or plan IDs. */
(() => {
  class PurchasePresentation extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.observer) return;
        this.root = this.closest('section[id^="MainProduct-"], product-info, [id^="ProductInfo-"]');
        const data = this.querySelector('script[type="application/json"]');
        if (!this.root || !data) return;
        this.labels = JSON.parse(data.textContent);
        this.abort = new AbortController();
        this.root.addEventListener('click', event => {
          if (!event.target.closest('[data-beleaev-description-link]')) return;
          const description = this.descriptionDetails();
          if (!description) return;
          event.preventDefault();
          description.open = true;
          description.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }, { signal: this.abort.signal });
        this.observer = new MutationObserver(() => this.apply());
        this.observer.observe(this.root, { childList: true, characterData: true, subtree: true });
        this.apply();
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.observer = null; }
    descriptionDetails() {
      return this.root.querySelector('details[id*="collapsible_tab_description"]') || [...this.root.querySelectorAll('.product__accordion details')].find(details => /^(description|beschreibung|descripción)\b/i.test(details.querySelector('summary')?.textContent.trim() || ''));
    }
    apply() {
      if (!this.isConnected) return;
      const template = this.root.querySelector('template[data-beleaev-description]');
      const content = template && this.descriptionDetails()?.querySelector('.accordion__content.rte');
      if (content && content.innerHTML.trim() !== template.innerHTML.trim()) content.innerHTML = template.innerHTML;
      this.root.querySelectorAll('.appstle_sub_widget, .appstle-tootltip-parent').forEach(widget => {
        const title = widget.querySelector('.appstle_widget_title');
        const caviarTitle = this.labels['Subscribe & Save up to 25% on Caviar from 30g'];
        if (title && this.root.querySelector('beleaev-caviar-sample-rule') && caviarTitle && title.textContent !== caviarTitle) title.textContent = caviarTitle;
        const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (node.parentElement.closest('script, style')) continue;
          const original = node.textContent.trim();
          const replacement = this.labels[original];
          if (replacement && replacement !== original) node.textContent = node.textContent.replace(original, replacement);
        }
        widget.querySelectorAll('a.appstle_subcription_link').forEach(link => {
          link.href = this.dataset.policyUrl;
          link.target = '_self';
          link.removeAttribute('rel');
          if (link.textContent !== this.labels['How subscriptions work']) link.textContent = this.labels['How subscriptions work'];
        });
      });
    }
  }
  if (!customElements.get('beleaev-purchase-presentation')) customElements.define('beleaev-purchase-presentation', PurchasePresentation);
})();
